'use client';

import { c as _c } from "react/compiler-runtime";
import type { KeenSliderInstance } from 'keen-slider';
import Image from 'next/image';
import { useRef } from 'react';
import { galleryImages } from '@/app/_content/data/gallery-images';
import LinkButtonPrimary from '../_lib/ui/LinkButtonPrimary';
import Carousel from './Carousel';
interface GalleryProps {
  isDevelopment?: boolean;
}
const Gallery = t0 => {
  const $ = _c(10);
  const {
    isDevelopment: t1
  } = t0;
  const isDevelopment = t1 === undefined ? false : t1;
  const sliderRef = useRef(null);
  const carouselRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="max-w-3xl mx-auto text-center mb-12"><h2 id="gallery-heading" className={"text-4xl md:text-5xl font-bold text-primary dark:text-primary-light text-center mb-6 pb-4 relative font-serif tracking-tight after:content-[\"\"] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-linear-to-r after:from-primary after:to-primary-light dark:after:from-primary-light dark:after:to-primary after:rounded"}>Photo Gallery</h2><p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">Take a virtual tour of our facilities and see what makes {process.env.NEXT_PUBLIC_APP_NAME} special.</p></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div ref={carouselRef}><Carousel images={galleryImages} isGallery={true} prioritizeFirstImage={true} onSliderReady={slider => {
        sliderRef.current = slider;
      }} /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isDevelopment) {
    t4 = galleryImages.map((image, index) => <div key={image.id} role="button" tabIndex={0} className="relative aspect-square w-full overflow-hidden rounded-lg cursor-pointer transition-transform hover:scale-105 group" onClick={() => {
      if (sliderRef.current) {
        sliderRef.current.moveToIdx(index);
        carouselRef.current?.scrollIntoView({
          behavior: "smooth"
        });
      }
    }} onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        if (sliderRef.current) {
          sliderRef.current.moveToIdx(index);
          carouselRef.current?.scrollIntoView({
            behavior: "smooth"
          });
        }
        e.preventDefault();
      }
    }} aria-label={`View ${image.caption} in slideshow`}><Image src={image.src} alt={image.caption} width={200} height={200} className="object-cover w-full h-full" sizes="(max-width: 768px) 50vw, (max-width: 1024px) 25vw, 16vw" loading="lazy" quality={75} /><div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />{isDevelopment && <div className="absolute bottom-0 left-0 right-0 bg-black/70 p-1 text-white text-xs truncate">{index + 1}/{galleryImages.length}</div>}</div>);
    $[2] = isDevelopment;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="mt-8"><div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 px-4">{t4}</div></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">Want to see our facility in person? We'd love to show you around!</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-12 text-center">{t6}<LinkButtonPrimary href="#contact-us" aria-label="Schedule a tour of our facility" className="group">Schedule a Tour<svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden={true}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg></LinkButtonPrimary></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5) {
    t8 = <section className="bg-white dark:bg-gray-900 py-16 md:py-24" id="photo-gallery" aria-labelledby="gallery-heading"><div className="container mx-auto px-4 sm:px-6">{t2}{t3}{t5}{t7}</div></section>;
    $[8] = t5;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
export default Gallery;